/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
  radioGroupQuarterNameDisputes,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  TO_DATE_GREATER_THAN_FROM,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getRebateProgrameList,
  getPlanTypeValues,
  getManufacturerList,
  getCurrentZeroResult,
  setSearchInput,
  setCurrentZeroUra,
} from '../Store/action';
import {
  autoFormateDate,
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ManufactureTableHead } from './tableHeads';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as Constants from '../../../../SharedModules/AppConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { compareDate } from '../../../../SharedModules/utilities/dateUtilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqCurrentZeroURA(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    // selectedPlanType,
    // rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    // isAllManufacturersSelected: isAllManufacturersSelectedValue,
    // scrollDownManufacturers: scrollDownManufacturersValue,
    // isNDCChecked: isNDCCheckedValue,
    // fromQuarter: fromQuarterValue,
    // toQuarter: toQuarterValue,
    currentZeroResult,
    selectedRowIndexValue,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      fromQuarter: fromQuarterValue,
      toQuarter: toQuarterValue,
      isNDCChecked: isNDCCheckedValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      scrollDownManufacturers: scrollDownManufacturersValue,
    },
  } = useSelector((state) => state?.sharedState?.CurrentZeroURAReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = useState([]);
  const [planType, setPlanType] = useState(selectedPlanType);
  const [selectList, setSelectList] = useState([]);
  const [rebateProgram, setRebateProgram] = useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = useState(
    rebateProgramNameValue
  );
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [errorList, setErrorList] = useState(errors);
  const [fromQuarter, setFromQuarter] = useState(fromQuarterValue);
  const [toQuarter, setToQuarter] = useState(toQuarterValue);
  const [isNDCChecked, setIsNDCChecked] = useState(isNDCCheckedValue);
  const [fullScreenView, setfullScreenView] = useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [manufacturerList, setManufacturerList] = useState([]);
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] = useState(
    isAllManufacturersSelectedValue
  );
  const [scrollDownManufacturers, setScrollDownManufacturers] = useState(
    scrollDownManufacturersValue
  );
  const [manufacturer, setManufacturer] = React.useState('ALL');
  const [manufacturerName, setManufactureName] = useState('');
  const [selectedRowIndex, setSelectedRowIndex] = useState(
    selectedRowIndexValue
  );

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  // After each time once plantype changes rebateprogram list get updated using this API call
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };
  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    const quarterVal = autoFormateDate(value?.toUpperCase());
    let localErrors = errorList;
    let toError = [];
    if (type === 'fromQtr') {
      let qtrErr = [];
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      if (!value)
        qtrErr = [
          { field: 'qtr', message: constantMessageData.FROM_QTR_REQUIRED },
        ];
      else if (validateQuarter(quarterVal, 'qtr')?.length) {
        qtrErr = validateQuarter(quarterVal, 'qtr');
      }
      setFromQuarter(quarterVal?.toUpperCase());
      localErrors = [...localErrors, ...qtrErr];
     // if (!toQuarter && !qtrErr.length) setToQuarter(quarterVal);
    }
    if (type === 'toQtr') {
      setToQuarter(quarterVal?.toUpperCase());
      if (value != '') {
        toError = validateQuarter(quarterVal, 'toQtr');
        localErrors = [...localErrors, ...toError];
      }
    }
    setErrorList(localErrors);
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    const manuError = [];
    const selectedRows = e.api?.getSelectedRows();
    if (selectedRows?.length > 0) {
      setManufacturer(selectedRows[0]?.mfgId);
      setManufactureName(selectedRows[0]?.mfgName);
    } else {
      setManufacturer('');
      setManufactureName('');
    }
    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    let selectedIndexes = '';
    manufacturerList.forEach((item, index) => {
      if (selectedMfgId?.indexOf(item.mfgId) != -1) {
        selectedIndexes = index;
      }
    });

    setSelectedRowIndex(selectedIndexes);
    setErrorList(manuError);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (!onDoubleClick && manufacturer.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    if (onDoubleClick && selectedRowOnDoubleClick.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    if (fromQuarter.length === 0) {
      allErrors.push({
        field: 'qtr',
        message: 'From Quarter is required',
      });
    }
    if (allErrors.length === 0) {
      if (compareDate(fromQuarter, toQuarter)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }

    allErrors = [...allErrors, ...errorList];
    setErrorList(allErrors);

    let tempIndexes = '';
    if (onDoubleClick) {
      manufacturerList.forEach((item, index) => {
        if (
          selectedRowOnDoubleClick &&
          selectedRowOnDoubleClick[0]?.mfgId === item.mfgId
        ) {
          tempIndexes = index;
        }
      });
    }

    if (allErrors.length === 0) {
      dispatch(setCurrentZeroUra([]));
      setSearchClicked(true);
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgramName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
        rebateProgramName?.shortDescr || ''
      }`;
      dispatch(
        setSearchInput({
          errors: allErrors,
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramName,
          manufacturer: onDoubleClick ? selectedRowOnDoubleClick : manufacturer,
          selectedRowIndexValue: onDoubleClick ? tempIndexes : selectedRowIndex,
          isNDCChecked,
          fromQuarter,
          toQuarter,
          manufacturerName,
          isAllManufacturersSelected,
          scrollDownManufacturers,
          isNDCChecked,
          searchScreenVar: {
            rebateProgramName,
            rebateProgramValue: rebateProgram,
            selectedPlanType,
            fromQuarter,
            toQuarter,
            isNDCChecked,
            isAllManufacturersSelected,
            scrollDownManufacturers,
          },
        })
      );
      if (!toQuarter) {
        setToQuarter(fromQuarter);
      }
      dispatch(
        getCurrentZeroResult({
          aiIncludeMissing: isNDCChecked ? '1' : '0',
          asMfg: onDoubleClick
            ? selectedRowOnDoubleClick[0]?.mfgId
            : manufacturer,
          asRpc: rebateProgram,

          asStartQtr: fromQuarter,

          asEndQtr: toQuarter === '' ? fromQuarter : toQuarter,
        })
      );
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const cellClickedListener = (e) => {
    setManufacturer([e?.data]);
    handleSearchClick(null, true, [e?.data]);
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);

  if (isSearchClicked && currentZeroResult && currentZeroResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispCurrentZeroURA',
      value: 'Display Current Zero URA Rpt',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/dispCurrentZeroURA',
    });
    dispatch(clearReduxForFilterAndSort('/dispCurrentZeroURA'));
  }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  const [gridApi, setGridApi] = React.useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || manufacturerList === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
      onSelectionChanged({ api: gridApi }); 
    }
  }, [gridApi, manufacturerList]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      {!fullScreenView && (
        <div className="tab-body">
          <>
            <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
            <CustomSeparator
              parent1="Detail Reports"
              parent2="Current Zero URA"
            />

            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="chip-chscn-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    handleOnChangeEvent(value, 'planTypeCd');
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <>
                  <Fieldset label="Rebate Program" required>
                    <div>
                      <SelectBoxComponent
                        data-testid="chip-cshcn-Rebate-Program"
                        id="filter-plan-by-radio-btn-action"
                        labelName="Rebate Program"
                        required
                        select
                        selectOne
                        optionList={selectList || []}
                        defaultValue={rebateProgram}
                        filterAction={(value) => {
                          setRebateProgram(value);
                          setRebateProgramName(value);
                          let errors;
                          if (value != -1 && value)
                            errors = errorList.filter(
                              (error) => error.field !== 'rebateProgram'
                            );
                          else
                            errors = [
                              ...errorList,
                              {
                                field: 'rebateProgram',
                                message: REBATE_SELECT,
                              },
                            ];
                          setErrorList([...errors]);
                        }}
                        isError={
                          errorList.find(
                            (error) => error.field === 'rebateProgram'
                          )?.message
                        }
                      />
                    </div>
                  </Fieldset>
                </>
              </div>
              <div className="col-4" style={{ marginTop: '45px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAllManufacturersSelected}
                      color="primary"
                      name="allManufacturers"
                      onChange={async (e) => {
                        setIsAllManufacturersSelected(
                          !isAllManufacturersSelected
                        );
                        setScrollDownManufacturers(!scrollDownManufacturers);
                        if (!isAllManufacturersSelected) {
                          setManufacturer('ALL');
                        } else {
                          setManufacturer('');
                        }
                        const elem = document.getElementById('abc11');
                        if (elem && scrollDownManufacturers) {
                          await Promise.resolve()
                          // setTimeout(() => {
                            elem.scrollIntoView();
                          // }, 1000);
                        }
                        const errors = errorList.filter(
                          (error) => error.field !== 'manufacturer'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'manufacturer'
                        )?.message
                      }
                    />
                  } 
                  label="All Manufacturers"
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-5">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    {radioGroupQuarterNameDisputes}{' '}
                    <span className="mandatory"> *</span>{' '}
                  </legend>

                  <div className="mui-custom-form input-md field-xl">
                    <div className="row">
                      <div className="col-5 mui-custom-form input-md field-xl ml-2 mr-0">
                        <TextField
                          label="From"
                          id="From"
                          data-testid="req-NDC-payment-quarter"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ maxLength: 6, id: 'From' }}
                          name="from"
                          value={fromQuarter}
                          error={
                            errorList.filter((error) => error.field === 'qtr')
                              ?.length > 0
                              ? 'mandate-fields'
                              : ''
                          }
                          helperText={
                            errorList.find((error) => error.field === 'qtr')
                              ?.message
                          }
                          className="mandate-fields"
                          onBlur={(e) =>
                            handleOnBlur('fromQtr', e.target.value)
                          }
                          onChange={(e) => {
                            const { value } = e.target;
                            setFromQuarter(value);
                            const localErrors = errorList.filter(
                              (error) => error.field != 'qtr'
                            );
                            setErrorList(localErrors);
                          }}
                        />
                      </div>
                      <div className="col-5 mui-custom-form input-md field-xl ml-0">
                        <TextField
                          label="To"
                          id="To"
                          data-testid="req-NDC-payment-quarter"
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{ maxLength: 6, id: 'To' }}
                          name="to"
                          value={toQuarter}
                          error={
                            errorList.filter(
                              (error) =>
                                error.field === 'toQtr' ||
                                error.field === 'fromDate>toDate'
                            )?.length > 0
                              ? 'mandate-fields'
                              : ''
                          }
                          helperText={
                            errorList.find(
                              (error) =>
                                error.field === 'toQtr' ||
                                error.field === 'fromDate>toDate'
                            )?.message
                          }
                          className="mandate-fields"
                          onBlur={(e) => handleOnBlur('toQtr', e.target.value)}
                          onChange={(e) => {
                            const { value } = e.target;
                            setToQuarter(value);
                            const localErrors = errorList.filter(
                              (error) =>
                                error.field != 'toQtr' &&
                                error.field !== 'fromDate>toDate'
                            );
                            setErrorList(localErrors);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="col-4" style={{ marginTop: '65px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isNDCChecked}
                      color="primary"
                      name="Include NDC's not on CMS type"
                      data-testid="currZeroURA-NDC-CMS"
                      onChange={() => {
                        setIsNDCChecked(!isNDCChecked);
                      }}
                    />
                  }
                  label="Include NDC's not on CMS type"
                />
              </div>
            </div>
            <div className="float-right mt-2 hide-on-print" tabIndex={0}>
              <Button
                className="btn-success same-font-family"
                data-testid="currZeroUra-click-searchbtn"
                onClick={handleSearchClick}
              >
                <SVGComponent iconName="Icon-search" />
                {' Search'}
              </Button>
            </div>
          </>
        </div>
      )}
      <div id="abc11" style={{ marginTop: 15 }}>
        <>
          {!isAllManufacturersSelected && (
            <div className="mt-5">
              <TableGridWithFeatures
                onSelectionChanged={onSelectionChanged}
                cellClickedListener={cellClickedListener}
                selectRowIndex={selectedRowIndexValue}
                gridCall={onGridReady}
                columnDefs={ManufactureTableHead}
                rowData={manufacturerList || []}
                rowSelection="single"
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                hideTotalCount={false}
                exportFile
                fileName="Manufacturer List"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
                handleViewHistory={false}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 30) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          )}
        </>
      </div>
    </div>
  );
}
